module.exports = __webpack_public_path__ + "img/alipay.910efb9b.png";